import { MyOrganizationKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { GetMyOrganizationByIdRequest, GetMyOrganizationByIdResponse } from "@maven-rest/docs/Organization.dto";
import { OrganizationUrl } from "@maven-rest/docs/Organization.url";

export function useMyOrganizationByIdQuery(
  req: GetMyOrganizationByIdRequest,
  options?: SimpleQueryOptions<GetMyOrganizationByIdResponse, GetMyOrganizationByIdRequest>
) {
  return useBaseQuery({
    queryKey: [MyOrganizationKey.MyOrganizationById, String(req.organizationId)],
    fnOption: { url: OrganizationUrl.getMyOrganizationById(req.organizationId), request: req },
    ...options,
  });
}
